module.exports = __webpack_public_path__ + "assets/img/6.3fee92ba.gif";